import script from "./VAddressSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./VAddressSearch.vue?vue&type=script&setup=true&lang=js"

import "./VAddressSearch.vue?vue&type=style&index=0&id=4ad238b8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ad238b8"]])

export default __exports__